"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageOverdueHeader = void 0;
var react_1 = __importDefault(require("react"));
var enums_1 = require("../../shared/enums");
var material_1 = require("@mui/material");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
var typeography_common_1 = require("../typeography/typeography.common");
var il_student_header_1 = require("../il-student-header/il-student-header");
function ManageOverdueHeader(_a) {
    var title = _a.title, studentProps = _a.studentProps, onClose = _a.onClose, innerRef = _a.innerRef;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !!title && (react_1.default.createElement(material_1.Box, { sx: {
                alignItems: 'center',
                justifyContent: 'space-between',
                display: 'flex',
                mb: '1.5rem',
                mt: '1rem',
                mx: '1rem',
            } },
            react_1.default.createElement(material_1.IconButton, { "data-testid": "back-courses", disableRipple: true, sx: { p: 0 }, onClick: function () {
                    var _a;
                    (_a = innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) === null || _a === void 0 ? void 0 : _a.click();
                    onClose && onClose();
                } },
                react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.CHEVRON_LEFT, size: enums_1.IconSizeEnum.SMALL })),
            react_1.default.createElement(typeography_common_1.ILH3, { sx: { fontSize: { xs: '1.15rem', sm: '1.375rem' } } }, title),
            react_1.default.createElement("div", null))),
        react_1.default.createElement(il_student_header_1.IlStudentHeader, __assign({}, studentProps, { sx: {
                mx: '1.5rem',
                '& .MuiAvatar-root': {
                    width: '2rem',
                    height: '2rem',
                },
            } })),
        react_1.default.createElement(material_1.Divider, { sx: { mt: '1rem' } })));
}
exports.ManageOverdueHeader = ManageOverdueHeader;
